import React, { useEffect, useState } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import { SELECTED_FEATURES } from "../../../../components/views/TenantSignUp/tenantSignUpConstants";
function DataControlPlatformChanges() {
  const [dataControlEnabled, setDataControlEnabled] = useState(false);

  const dispatch = useDispatch();

  const licenceTypeData = useSelector(
    (state) => state.tenantSignUpReducer?.licenceTypeData || []
  );

  const featureData = useSelector(
    (state) => state.tenantSignUpReducer?.featureData || []
  );

  const selectedFeatures = useSelector(
    (state) => state.tenantSignUpReducer?.selectedFeatures || []
  );

  const dataControlFeature = featureData.find(
    (feature) => feature.name === "Data Control"
  );

  const silverLicense = licenceTypeData.find(
    (license) => license.name === "Silver"
  );

  useEffect(() => {
    if (!dataControlFeature) {
      return;
    }

    const dataControl = selectedFeatures.find(
      (item) => item.featureId === dataControlFeature.id
    );

    setDataControlEnabled(
      dataControl?.licenseTypeId === silverLicense?.id
    );
  }, [dataControlFeature, selectedFeatures, silverLicense]);

  const handleToggle = (event) => {
    const enabled = event.target.checked;

    setDataControlEnabled(enabled);

    let data = [...selectedFeatures];

    let index;

    data.forEach((item, id) => {
      if (item.featureId === dataControlFeature.id) {
        index = id;
      }
    });

    if (index !== undefined) {
      data[index].licenseTypeId = enabled
        ? silverLicense.id
        : "None";
    }

    dispatch({
      type: SELECTED_FEATURES,
      payload: data,
    });
  };

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={dataControlEnabled}
            onChange={handleToggle}
            color="primary"
          />
        }
        label="Data Control"
      />
    </div>
  );
}

export default DataControlPlatformChanges;